/**
 * Created by Tiger on 16/03/2022.
 */
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import mapStateToProps from '../../redux/util';
import zhData from './data.json';
import enData from './data_en.json';
import {Select, Space, Typography} from 'antd';
import styled from '@emotion/styled';

const CountryCode = props => {
    const [data, setData] = useState([]);
    useEffect(() => {
        if (props.locale.includes('zh')) {
            setData([...zhData]);
        } else {
            setData([...enData]);
        }
    }, [props.locale]);

    return (
        <SelectContainer>
            <Select  bordered={ false } style={ { minWidth: 50 } } dropdownMatchSelectWidth={ 250 } showSearch={ true }
                    optionFilterProp={ 'label' } defaultValue={ '86' } onChange={ props.onChange }>
                {
                    data.map(({ key, data }, index) => {
                        return <Select.OptGroup key={ `${ key }${ index }` } label={ key }>
                            {
                                data.map(({ countryName, phoneCode }, index) => {
                                    return <Select.Option key={ `${ index }-${ phoneCode }` }
                                                          label={ `+${ phoneCode } ${ countryName }` }
                                                          value={ phoneCode }>
                                        <Space direction={ 'horizontal' }>
                                            <PhoneCodeContainer>
                                                <Typography.Text>{ `+${ phoneCode }` }</Typography.Text>
                                            </PhoneCodeContainer>
                                            { !!props.displayName &&
                                                <Typography.Text>{ `${ countryName }` }</Typography.Text> }
                                        </Space>
                                    </Select.Option>;
                                })
                            }
                        </Select.OptGroup>;
                    })
                }
            </Select>
        </SelectContainer>
    );
};

const PhoneCodeContainer = styled.div`
  width: 30px;
`;

const SelectContainer = styled.div`
  border-bottom: ${ props => props.bordered ? `1px solid rgba(0,0,0,0.2);` : null }
  margin-right: 5px;
`;

export default connect(mapStateToProps, null)(CountryCode);


